import React, { FC, useContext } from 'react'

import { Photo } from 'components/page/ForeignProfile/common.types'
import { ForeignPhotoContext } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { skipEndPointIncognito } from 'components/page/ForeignProfile/Photos/function/skipEndPointIncogito'
import {
  Image,
  ImageHuge,
  Source,
} from 'components/page/ForeignProfile/Photos/Photos.styled'
import { PhotosType } from 'components/page/ForeignProfile/Photos/PhotosTile/PhotosTile.types'

export const MainPhoto: FC<{ mainPhoto: Photo }> = ({ mainPhoto }) => {
  const { baseHrefPhoto, useAuthorizationUrl } = useContext(ForeignPhotoContext)

  return (
    <ImageHuge
      key={mainPhoto.photoId}
      to={skipEndPointIncognito(
        baseHrefPhoto,
        mainPhoto.photoId,
        useAuthorizationUrl
      )}
      data-name={`photoviewer-${mainPhoto.photoId}-action`}
    >
      <picture>
        {mainPhoto.urls.xHuge && (
          <Source
            srcSet={mainPhoto.urls.xHuge}
            $coordinates={mainPhoto.faceCenter}
            $type={PhotosType.huge}
            width={mainPhoto.width}
            height={mainPhoto.height}
            type="image/webp"
            data-name={`photoviewer-${mainPhoto.photoId}-photo`}
          />
        )}
        <Image
          src={mainPhoto.urls.huge}
          $coordinates={mainPhoto.faceCenter}
          $type={PhotosType.huge}
          width={mainPhoto.width}
          height={mainPhoto.height}
          data-name={`photoviewer-${mainPhoto.photoId}-photo`}
        />
      </picture>
    </ImageHuge>
  )
}
